import { gql } from '@apollo/client';

export const USER = gql`
  fragment user on User {
    id

    addOns {
      id
      name
    }
    contactNumber
    designation
    email
    embedCode
    firstName
    funder {
      id
      name
    }
    gender
    idNum
    institution {
      id
      name
      ministry {
        id
        name
      }
      type {
        id
        name
      }
    }
    lastLogin
    lastName
    permissions {
      id
      name
    }
    plan {
      id
      name
    }
    dataRole
    registrationRole {
      id
      name
    }
    roles {
      id
      name
    }
    serviceProvider {
      id
      name
    }
    status
    title
    authMetaData {
      id
      duration
    }
    createdAt
    persalNumber
  }
`;
